import { WithStyles, withStyles } from '@mui/styles';

import { muiStyles } from './styles';
import { TermsOfUse } from './termsOfUse';

export type TermsOfUseProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(TermsOfUse);